import * as React from 'react';
import Dialog from 'src/components/common/Dialog';
import Form from 'src/components/controls/forms/Form';
import Textbox from 'src/components/controls/forms/redesign/FormTextbox';
import Button from 'src/components/controls/forms/redesign/FormButton';
import DialogList from 'src/dialogs';
import PerformanceComment from 'src/models/PerformanceComment';
import Landman from 'src/models/Landman';

interface IAddCommentDialogProps {
    landman: Landman;
    createPerformanceComment: (performanceComment: PerformanceComment) => void;
}
class AddCommentDialog extends React.Component<IAddCommentDialogProps> {
    handleAddCommentSubmit = (values: { comment: string }) => {
        const performanceComment = new PerformanceComment();
        performanceComment.authorId = this.props.landman.id;
        performanceComment.commentText = values.comment;
        performanceComment.commentDate = new Date();
        performanceComment.userId = this.props.landman.id;
        performanceComment.isApproved = false;

        this.props.createPerformanceComment(performanceComment);
    };
    public render() {
        return (
            <Dialog dialogName={DialogList.ADD_COMMENT} title="Add a Comment">
                <Form onSubmit={this.handleAddCommentSubmit}>
                    <Textbox name="comment" label="Comment" />
                    <Button type="submit" text="Add Comment" />
                </Form>
            </Dialog>
        );
    }
}

export default AddCommentDialog;



// WEBPACK FOOTER //
// ./src/components/personnel/dialogs/AddCommentDialog.tsx